import React from 'react';

import CorpSubIcon from 'images/subscribe-icon-corporate.svg';

import { Button } from '../../BaseUI';
import styles from './styles.module.css';

const CorporateSubscriptionCard = ({
  trackingProps = {},
}: {
  trackingProps?: { [key: string]: string };
}) => {
  return (
    <div className={styles.corpSubCard}>
      <div className={styles.topBarCorp}></div>
      <img src={CorpSubIcon} alt="corporate subscription icon" />
      <div>
        <h4 className={styles.corpSubCardHeader}>Corporate Subscriptions</h4>
        <div className={styles.corpSubCardSubtitle}>
          Get a corporate subscription for your team.
        </div>
      </div>
      <Button
        href="mailto:corporate@theinformation.com"
        rounded="full"
        trackClick={Object.keys(trackingProps).length > 0}
        trackingProps={trackingProps}
      >
        contact sales
      </Button>
    </div>
  );
};

export default CorporateSubscriptionCard;
